import React, { useMemo, useState } from 'react';
import { FileDownloadIcon } from './icons';
import ApprovedRejectIcon from '../../../components/ApprovedRejectIcon';
import { useSelector } from 'react-redux';
import { TicketAgentRole } from '../../../../Ticket/TicketController';
import { useExif } from '../../../../../hooks/useExif';
import useHeicImage from '../../../../../hooks/useHeicImage';
const pxToRem = (pixels) => {
    if (parseInt(pixels)) {
        return pixels / parseInt(getComputedStyle(document.documentElement).fontSize)
    }
    return 0
};

export const getImageStyle = (height) => {
    let remValue = pxToRem(height)
    if (remValue >= 48) {
        return '48rem'
    } else remValue = 48;
    return `${remValue}rem`;
}

export default function Image({
    fileUrl,
    fileName,
    mimeType,
    conversationId,
    attachmentId,
    messageId,
    downloadFile,
    onAttachmentClick,
    callStepFields,
    height,
    is_rejected,
    is_approved,
    approver,
    rejector,
    is_duplicate,
    duplicate_references
}) {
    const serviceRequestData = useSelector((state) => state.serviceRequest.serviceRequestData);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const supportTrackServiceRequest = useSelector((state) => state.serviceRequest.supportTrackServiceRequest);
    const serviceRequestList = useSelector((state) => state.serviceRequest.serviceRequestList);

    const { location } = useExif(fileUrl);
    const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
    const { src: renderSrc, isConverting: isConvertingHeic } = useHeicImage(fileUrl, mimeType);

    const handleDuplicateItemClick = (item) => {
        if (item.ticket_id && item.message_id) {
            const chatUrl = `/chats/${item.ticket_id}?messageId=${item.message_id}`;
            window.open(chatUrl, '_blank');
        }
        setShowDuplicatePopup(false);
    };

    const showApprovalOptions = useMemo(() => {
        let serviceRequest = serviceRequestData[conversationId];
        if (window.location.pathname.includes('support/track')) {
            serviceRequest = supportTrackServiceRequest;
        }
        if (!serviceRequest && serviceRequestList?.data?.length > 0) {
            serviceRequest = serviceRequestList.data.find((el) => el.id === conversationId);
        }
        if (serviceRequest && serviceRequest.agents) {
            const isAdmin = serviceRequest.agents.find(({ role, agent }) => {
                return role === TicketAgentRole.SCM && agent.id === newLoggedUserData.user.id;
            });
            const isCustomer = serviceRequest.helpdesk_id === newLoggedUserData.org.id;
            return { showApprove: (isAdmin || isCustomer) && !is_approved && !is_rejected, isAdmin };
        }
        return { showApprove: false, isAdmin: false };
    }, [serviceRequestData, conversationId, newLoggedUserData, supportTrackServiceRequest, is_rejected, is_approved, serviceRequestList.data]);

    return (
        <div className='relative w-full h-full p-1' style={{ maxHeight: getImageStyle(height), overflow: 'hidden' }}>
            <img src={renderSrc} className='w-full h-full object-cover' alt='' style={{ maxHeight: getImageStyle(height), overflow: 'hidden' }} />
            {isConvertingHeic && (
                <div className='absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm text-white text-sm font-medium z-10'>
                    Loading...
                </div>
            )}
            <div
                className='absolute top-1 attachmentGlassEffect p-1 w-full h-full'
                onClick={() => {
                    onAttachmentClick();
                }}
            ></div>
            <FileDownloadIcon position='top-5 right-5' onClick={() => downloadFile({ fileUrl, fileName, mimeType })} />
            {is_duplicate && duplicate_references && duplicate_references.length > 0 && (
                <div
                    className='absolute top-5 left-5 bg-gradient-to-r from-red-500 to-red-600 text-white px-3 py-1.5 rounded-lg text-xs font-medium shadow-lg border border-red-400 backdrop-blur-sm bg-opacity-90 cursor-pointer hover:from-red-600 hover:to-red-700 transition-all duration-200'
                    onClick={() => setShowDuplicatePopup(true)}
                >
                    <span className='flex items-center gap-1'>
                        {/* <span className='material-icons text-sm'>content_copy</span> */}
                        <span>Duplicate ({duplicate_references.length})</span>
                        <span className='material-icons text-sm'>expand_more</span>
                    </span>
                </div>
            )}
            <div className='absolute flex gap-2 right-5 bottom-5 '>
                <ApprovedRejectIcon
                    showApprovalOptions={showApprovalOptions}
                    is_approved={is_approved}
                    is_rejected={is_rejected}
                    approver={approver}
                    rejector={rejector}
                    conversationId={conversationId}
                    messageId={messageId}
                    attachmentId={attachmentId}
                    isCardMessage={false}
                    chat_id={conversationId}
                />
            </div>
            {location && location.latitude && location.longitude && (
                <div className='absolute bottom-5 left-5 bg-gradient-to-r from-blue-500 to-blue-600 text-white px-3 py-1.5 rounded-lg text-xs font-medium shadow-lg border border-blue-400 backdrop-blur-sm bg-opacity-90'>
                    <span onClick={() => {
                        window.open(`https://maps.google.com?q=${`${location.latitude}, ${location.longitude}`}`, '_blank');
                    }}
                        className='flex items-center gap-1 cursor-pointer'>
                        <span className='material-icons text-sm'>location_on</span>
                        <span>
                            {location.latitude.toFixed(4)}, {location.longitude.toFixed(4)}
                        </span>
                    </span>
                </div>
            )}

            {/* Duplicate References Popup */}
            {showDuplicatePopup && duplicate_references && duplicate_references.length > 0 && (
                <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm'>
                    <div className='bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 max-h-96 overflow-hidden'>
                        {/* Header */}
                        <div className='bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-2 flex items-center justify-between'>
                            <div className='flex items-center gap-2'>
                                {/* <span className='material-icons text-font14'>content_copy</span> */}
                                <h3 className='font-semibold text-lg'>Duplicate References ({duplicate_references.length})</h3>
                            </div>
                            <button
                                onClick={() => setShowDuplicatePopup(false)}
                                className='hover:bg-red-600 rounded-full p-1 transition-colors duration-200'
                            >
                                <span className='material-icons'>close</span>
                            </button>
                        </div>

                        {/* Content */}
                        <div className='max-h-80 overflow-y-auto'>
                            {duplicate_references.map((item, index) => (
                                <div
                                    key={item.id || index}
                                    className={`p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200 ${item.ticket_id && item.message_id ? 'cursor-pointer' : 'cursor-not-allowed opacity-60'}`}
                                    onClick={() => handleDuplicateItemClick(item)}
                                >
                                    <div className='flex items-start gap-3'>
                                        {/* Thumbnail */}
                                        <div className='flex-shrink-0'>
                                            <img
                                                src={item.url}
                                                alt='Duplicate'
                                                className='w-12 h-12 object-cover rounded-lg border border-gray-200'
                                            />
                                        </div>

                                        {/* Content */}
                                        <div className='flex-1 min-w-0'>
                                            <div className='flex items-center gap-2 mb-1'>
                                                <span className='material-icons text-sm text-gray-500'>image</span>
                                                <span className='text-sm font-medium text-gray-900 truncate'>
                                                    Reference #{index + 1}
                                                </span>
                                            </div>

                                            {(item.ticket_number || item.ticket_id) && (
                                                <div className='flex items-center gap-1 mb-1'>
                                                    <span className='material-icons text-xs text-blue-500'>confirmation_number</span>
                                                    <span className='text-xs text-gray-600 truncate'>
                                                        Ticket: {item.ticket_number || item.ticket_id}
                                                    </span>
                                                </div>
                                            )}

                                            {/* {item.message_id && (
                                                <div className='flex items-center gap-1 mb-1'>
                                                    <span className='material-icons text-xs text-green-500'>message</span>
                                                    <span className='text-xs text-gray-600 truncate'>
                                                        Message: {item.message_id}
                                                    </span>
                                                </div>
                                            )} */}

                                            {item.ticket_id && item.message_id ? (
                                                <div className='flex items-center gap-1 mt-2'>
                                                    <span className='material-icons text-xs text-blue-500'>open_in_new</span>
                                                    <span className='text-xs text-blue-500 font-medium'>Click to open chat</span>
                                                </div>
                                            ) : (
                                                <div className='flex items-center gap-1 mt-2'>
                                                    <span className='material-icons text-xs text-gray-400'>block</span>
                                                    <span className='text-xs text-gray-400'>No navigation available</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
